import { Route, Routes } from 'react-router-dom'
import Tabs, { tabConfig } from './Tabs'
import { BasePathProvider } from 'components/Providers'
import { Box } from '@mui/material'
import PageHeader from 'components/AppBar/PageHeader'
import DailyAttendance from './Daily'
import StudentAttendance from './Student'
import TeacherAttendance from './Teacher'
import AttendanceSettings from './Settings'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import NotFound from 'components/NotFound'
import Protected from 'components/Protected'

export default function SchoolAttendance() {
  const basePath = '/attendance'

  return (
    <BasePathProvider value={`${basePath}/`}>
      <Box sx={{ mb: 2 }}>
        <PageHeader title={'Attendance'} />
      </Box>
      <Tabs />
      <Routes>
        <Route path="/">
          <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
          <Route path="daily/*" element={<Protected permission="attendance.admin"><DailyAttendance /></Protected>} />
          <Route path="student/*" element={<Protected permission="attendance.admin"><StudentAttendance /></Protected>} />
          <Route path="teacher/*" element={<Protected permission="attendance.teacher"><TeacherAttendance /></Protected>} />
          <Route path="settings/*" element={<Protected permission="attendance.settings"><AttendanceSettings /></Protected>} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BasePathProvider>
  )
}
